/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


(function () {
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches('.color-swatch__radio[data-qfm-card-price]') || input.disabled) return;
    var card = input.closest('.product-item');
    if (!card) return;
    var price = card.querySelector('span[data-qfm-card-price]');
    var variant = card.querySelector('div[data-qfm-card-variant]');
    if (price) price.textContent = input.dataset.qfmCardPrice;
    if (variant) variant.textContent = input.dataset.qfmCardVariant;
    card.querySelectorAll('[data-qfm-card-choose]').forEach(function (link) { link.setAttribute('href', input.dataset.variantUrl); });
    card.querySelectorAll('[data-qfm-card-quick-view]').forEach(function (button) { button.setAttribute('data-product-url', input.dataset.variantUrl); });
  });
})();

;(() => {

  const oppoModelLinks = (href,className = 'mega-menu__link link') => {
    const data = document.getElementById('qfm-oppo-series-models');
    if (!data) return [];
    let products;
    try { products = JSON.parse(data.textContent)[href.split('/').filter(Boolean).pop()] || []; } catch { return []; }
    const seriesKey = href.match(/oppo-(k|reno|find|a|f|r)-series/)?.[1];
    const prefix = {k:/^K\d/i,reno:/^Reno(?:\s?\d|$)/i,find:/^Find\s[XN]/i,a:/^A\d/i,f:/^F\d/i,r:/^R\d/i}[seriesKey];
    return products.filter(product => prefix?.test(product.title) && !/\b(parts?|repair|battery|screen|display|hardware|replacement|compatible|variant|speaker|upgrade|series|mobile)\b/i.test(product.title)).sort((a,b)=>b.title.localeCompare(a.title,undefined,{numeric:true})).map(product => {
      const link = document.createElement('a');
      link.className = className + ' qfm-oppo-model-link';
      link.href = product.url + "/" + product.tag;
      link.textContent = product.title;
      link.title = product.title;
      return link;
    });
  };

  const setupSpareMenu = (trigger) => {
    const menu = trigger && document.getElementById(trigger.getAttribute('aria-controls'));
    if (!menu || menu.classList.contains('qfm-spare')) return;
    if (!menu.classList.contains('mega-menu')) {
      const sourceItems = Array.from(menu.children).filter(e => e.matches('li'));
      const container = document.createElement('div');
      container.className = 'container';
      const columns = document.createElement('div');
      columns.className = 'mega-menu__inner';
      sourceItems.forEach(item => {
        const sourceLink = Array.from(item.children).find(e => e.matches('a'));
        if (!sourceLink) return;
        const column = document.createElement('div');
        column.className = 'mega-menu__column';
        const title = sourceLink.cloneNode(true);
        title.querySelectorAll('svg').forEach(e => e.remove());
        title.className = 'mega-menu__title heading';
        ['aria-controls','aria-expanded','aria-haspopup','data-type'].forEach(a => title.removeAttribute(a));
        const list = document.createElement('ul');
        list.className = 'mega-menu__linklist';
        const nested = Array.from(item.children).find(e => e.matches('ul'));
        const sources = nested ? Array.from(nested.querySelectorAll('a')) : [sourceLink];
        sources.forEach(source => {
          const li = document.createElement('li');
          li.className = 'mega-menu__item';
          const link = source.cloneNode(true);
          link.querySelectorAll('svg').forEach(e => e.remove());
          link.className = 'mega-menu__link link';
          ['aria-controls','aria-expanded','aria-haspopup','data-type'].forEach(a => link.removeAttribute(a));
          li.append(link);
          list.append(li);
        });
        column.append(title,list);
        columns.append(column);
      });
      container.append(columns);
      menu.replaceChildren(container);
      menu.className = 'mega-menu';
      trigger.parentElement.classList.add('nav-bar__item--static');
    }
    const inner = menu.querySelector('.mega-menu__inner');

    if (trigger.textContent.trim() === 'Other Phones') {
      const oppo = Array.from(inner.querySelectorAll('.mega-menu__column')).find(column => column.querySelector('.mega-menu__title')?.textContent.trim() === 'Oppo');
      if (oppo) {
        const series = [];
        let active = null;
        oppo.querySelectorAll('.mega-menu__linklist a').forEach(link => {
          if (/series$/i.test(link.textContent.trim())) {
            active = {label:link.textContent.trim(),link,models:[]};
            series.push(active);
          } else if (active) active.models.push(link);
        });
        if (series.length) {
          const fragment = document.createDocumentFragment();
          series.forEach(entry => {
            const column = document.createElement('div');
            column.className = 'mega-menu__column';
            column.dataset.qfmBrand = 'Oppo';
            const heading = entry.link.cloneNode(true);
            heading.className = 'mega-menu__title heading';
            const list = document.createElement('ul');
            list.className = 'mega-menu__linklist';
            (entry.models.length ? [] : oppoModelLinks(entry.link.getAttribute('href'))).forEach(link => {
              const item = document.createElement('li'); item.className = 'mega-menu__item'; item.append(link); list.append(item);
            });
            entry.models.forEach(source => {
              const item = document.createElement('li');
              item.className = 'mega-menu__item';
              item.append(source.cloneNode(true));
              list.append(item);
            });
            const all = document.createElement('li');
            all.className = 'mega-menu__item';
            const allLink = entry.link.cloneNode(true);
            allLink.textContent = 'Shop all ' + entry.label;
            all.append(allLink);
            list.append(all);
            column.append(heading,list);
            fragment.append(column);
          });
          oppo.replaceWith(fragment);
        }
      }
    }
    const groups = Array.from(inner.querySelectorAll('.mega-menu__column'));
    if (!groups.length) return;
    menu.classList.add('qfm-spare');
    if (!document.getElementById('qfm-spare-styles')) {
      const style = document.createElement('style');
      style.id = 'qfm-spare-styles';
      style.textContent = `
@media(min-width:1000px){
.qfm-spare{width:100%!important;max-width:100vw!important;max-height:none!important;overflow:hidden!important;padding:0!important;box-shadow:0 12px 24px #102c4b24}
.qfm-spare>.container{max-width:1440px!important;padding:0 20px!important}
.qfm-spare .mega-menu__inner{display:grid!important;grid-template-columns:220px minmax(0,1fr);gap:0!important;align-items:stretch!important;min-height:0!important;grid-template-rows:minmax(0,1fr);height:var(--qfm-height,600px);margin:0!important;padding:0!important;overflow:hidden}
.qfm-spare .qfm-side{overflow-y:auto;overscroll-behavior:contain;border-right:1px solid #dce5ec;padding:16px 12px 16px 0}
.qfm-spare .qfm-side button{display:block;width:100%;padding:9px 14px;margin:0 0 3px;border:0;border-radius:22px;text-align:left;font:inherit;font-size:14px;line-height:20px;color:#192b3b;background:transparent;cursor:pointer}
.qfm-spare .qfm-side button:hover,.qfm-spare .qfm-side button:focus-visible{background:#e0f2f8}
.qfm-spare .qfm-side button[data-qfm-active=true]{background:#0867b4;color:white}
.qfm-spare .qfm-side button[data-qfm-pinned=true]{display:flex;align-items:center;gap:10px}
.qfm-spare .qfm-pin-icon{display:none;width:15px;height:15px;flex:none}
.qfm-spare .qfm-side button[data-qfm-pinned=true] .qfm-pin-icon{display:block}
.qfm-spare.qfm-menu-pinned{display:block!important;visibility:visible!important;opacity:1!important;pointer-events:auto!important;transform:none!important}
.qfm-spare .qfm-side button:focus-visible{outline:2px solid #f6a23d;outline-offset:2px}
.qfm-spare .qfm-body{min-width:0;display:flex;flex-direction:column;overflow:hidden}
.qfm-spare .qfm-search{margin:14px 20px 8px;padding:10px 14px;border:1px solid #b9cddc;border-radius:8px;width:calc(100% - 40px);font:inherit;font-size:14px;flex:none}
.qfm-spare .qfm-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));align-content:start;gap:28px 24px;padding:12px 20px 24px;overflow-y:auto;overscroll-behavior:contain;scrollbar-gutter:stable;min-height:0;flex:1}
.qfm-spare .mega-menu__column{width:auto!important;min-width:0!important;max-width:none!important;flex:none!important;margin:0!important;padding:0!important}
.qfm-spare .mega-menu__title{display:inline-block;margin:0 0 12px!important;padding:5px 14px;border-radius:24px;background:#e0f2f8;color:#132c40!important;font-size:14px;line-height:20px;white-space:normal}
.qfm-spare .mega-menu__linklist{margin:0!important;padding:0!important;list-style:none}
.qfm-spare .mega-menu__item{margin:0!important}
.qfm-spare .mega-menu__link{display:block;padding:5px 8px!important;font-size:14px;line-height:20px;overflow-wrap:anywhere;white-space:normal!important;color:#273947}
.qfm-spare .mega-menu__link:hover{color:#0068ba;background:#eef7fb}
.qfm-spare .qfm-more{font:inherit;font-size:14px;color:#143d5c;text-decoration:underline;font-weight:600;margin:8px 8px 0;border:0;background:transparent;cursor:pointer}
.qfm-spare [hidden]{display:none!important}
.qfm-spare .qfm-grid.qfm-selected{grid-template-columns:1fr}
.qfm-spare .qfm-selected .mega-menu__linklist{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:0 24px}
.qfm-spare .qfm-empty{padding:10px;color:#526676}
@media(max-width:1200px){.qfm-spare .mega-menu__inner{grid-template-columns:190px minmax(0,1fr)}.qfm-spare .qfm-grid{grid-template-columns:repeat(3,minmax(0,1fr))}}
}`;
      document.head.append(style);
    }
    const side = document.createElement('nav');
    side.className = 'qfm-side';
    side.setAttribute('aria-label',trigger.textContent.trim() + ' categories');
    const body = document.createElement('div');
    body.className = 'qfm-body';
    const input = document.createElement('input');
    input.className = 'qfm-search';
    input.type = 'search';
    input.placeholder = trigger.textContent.trim() === 'Spare Parts' ? 'Search spare parts models' : 'Search ' + trigger.textContent.trim().toLowerCase() + ' models';
    input.setAttribute('aria-label',input.placeholder);
    const grid = document.createElement('div');
    grid.className = 'qfm-grid';
    const empty = document.createElement('p');
    empty.className = 'qfm-empty';
    empty.textContent = 'No matching models. Try another search.';
    empty.hidden = true;
    const records = groups.map(group => ({
      group,
      title:group.querySelector('.mega-menu__title'),
      items:Array.from(group.querySelectorAll('.mega-menu__item'))
    }));
    let selected = -1;
    let pinned = null;
    const buttons = [];
    const render = () => {
      const query = input.value.trim().toLowerCase();
      let matches = 0;
      grid.classList.toggle('qfm-selected',selected >= 0);
      records.forEach((record,index) => {
        const relevant = selected === -1 || selected === index || (selected === -2 && record.group.dataset.qfmBrand === 'Oppo');
        const titleMatch = (record.title.textContent + ' ' + (record.group.dataset.qfmBrand || '')).toLowerCase().includes(query);
        let count = 0;
        record.items.forEach((item,itemIndex) => {
          const match = !query || titleMatch || item.textContent.toLowerCase().includes(query);
          item.hidden = !relevant || !match || (!query && selected < 0 && itemIndex >= 5);
          if (match) count++;
        });
        record.group.hidden = !relevant || (!!query && !titleMatch && !count);
        record.more.hidden = !!query || selected >= 0 || record.items.length <= 5;
        if (!record.group.hidden) matches++;
      });
      buttons.forEach(button => {
        const index = Number(button.dataset.qfmIndex);
        button.setAttribute('aria-pressed',String(index === pinned));
        button.dataset.qfmActive = String(index === selected);
        button.dataset.qfmPinned = String(index === pinned);
        button.title = index === pinned ? 'Click again to unpin' : 'Hover to preview; click to pin';
      });
      empty.hidden = matches > 0;
      menu.classList.toggle('qfm-menu-pinned',pinned !== null);
      if (pinned !== null) {
        menu.setAttribute('aria-hidden','false');
        trigger.setAttribute('aria-expanded','true');
      }
    };
    const closePinnedMenu = () => {
      pinned = null;
      render();
      menu.setAttribute('aria-hidden','true');
      trigger.setAttribute('aria-expanded','false');
    };
    document.addEventListener('click',event => {
      if (pinned !== null && !menu.contains(event.target) && !trigger.contains(event.target)) closePinnedMenu();
    },true);
    trigger.addEventListener('click',event => {
      if (pinned !== null) { event.preventDefault();event.stopImmediatePropagation();closePinnedMenu(); }
    },true);
    new MutationObserver(() => {
      if (pinned !== null) {
        if (menu.getAttribute('aria-hidden') !== 'false') menu.setAttribute('aria-hidden','false');
        if (trigger.getAttribute('aria-expanded') !== 'true') trigger.setAttribute('aria-expanded','true');
      }
    }).observe(menu,{attributes:true,attributeFilter:['aria-hidden']});
    const choose = (index,pin = false) => {
      if (pin && pinned === index) { pinned = null; render(); return; }
      if (pin) pinned = index;
      selected = index;
      input.value = '';
      render();
      grid.scrollTop = 0;
    };
    const addButton = (label,index) => {
      const button = document.createElement('button');
      button.type = 'button';
      const icon = document.createElementNS('http://www.w3.org/2000/svg','svg');
      icon.setAttribute('viewBox','0 0 24 24');icon.setAttribute('aria-hidden','true');icon.classList.add('qfm-pin-icon');
      icon.innerHTML = '<path d="M8 3h8l-2 5v4l3 3v2H7v-2l3-3V8L8 3Zm4 14v5" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round" stroke-linecap="round"/>';
      button.append(icon,document.createTextNode(label));
      button.dataset.qfmIndex = String(index);
      button.addEventListener('pointerenter',event => {
        if (event.pointerType === 'mouse' && pinned === null) choose(index);
      });
      button.addEventListener('focus',() => { if (pinned === null) choose(index); });
      button.addEventListener('click',() => choose(index,true));
      side.append(button);
      buttons.push(button);
    };
    addButton('All Categories',-1);
    let oppoButtonAdded = false;
    records.forEach((record,index) => {
      if (record.group.dataset.qfmBrand === 'Oppo' && !oppoButtonAdded) { addButton('Oppo',-2); oppoButtonAdded = true; }
      addButton(record.title.textContent.trim(),index);
      const isOppo = record.group.dataset.qfmBrand === 'Oppo';
      const more = document.createElement('button');
      more.type = 'button';
      more.className = 'qfm-more';
      more.textContent = 'View all models';
      more.addEventListener('click',() => { pinned = index; choose(index); });
      record.more = more;
      record.group.append(more);
      grid.append(record.group);
    });
    grid.append(empty);
    body.append(input,grid);
    inner.replaceChildren(side,body);
    const size = () => {
      const top = menu.getBoundingClientRect().top;
      menu.style.setProperty('--qfm-height',Math.max(120,Math.min(640,window.innerHeight - Math.max(0,top) - 16)) + 'px');
    };
    trigger.parentElement.addEventListener('pointerenter',() => requestAnimationFrame(size));
    trigger.addEventListener('focus',() => requestAnimationFrame(size));
    window.addEventListener('resize',size,{passive:true});
    input.addEventListener('input',render);
    menu.addEventListener('keydown',event => {
      if (event.key === 'Escape') {
        pinned = null;
        render();
        trigger.setAttribute('aria-expanded','false');
        menu.setAttribute('aria-hidden','true');
        trigger.focus();
      }
    });
    render();
    size();
  };

  const setupOppoMobile = () => {
    if (!document.getElementById('qfm-oppo-mobile-style')) {
      const style = document.createElement('style'); style.id = 'qfm-oppo-mobile-style';
      style.textContent = '.qfm-oppo-mobile-series summary{list-style:none;cursor:pointer;display:flex;justify-content:space-between;align-items:center}.qfm-oppo-mobile-series summary::-webkit-details-marker{display:none}.qfm-oppo-mobile-series summary:after{content:"+";font-size:20px;color:#087eb8}.qfm-oppo-mobile-series details[open]>summary:after{content:"−"}.qfm-oppo-mobile-series .qfm-oppo-mobile-models{padding-left:18px;border-left:2px solid #e4f1f8;margin-left:12px}.qfm-oppo-mobile-title{color:#0867b4}.qfm-oppo-model-link{display:-webkit-box!important;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;line-height:20px;max-height:50px}';
      document.head.append(style);
    }
    document.querySelectorAll('.mobile-menu__nav').forEach(list => {
      if (list.dataset.qfmOppoSeries) return;
      const title = Array.from(list.children).find(item => item.querySelector('a')?.textContent.trim() === 'Oppo');
      if (!title) return;
      const links = Array.from(list.querySelectorAll('a')).filter(a => a.getAttribute('href')?.includes('/spare-parts-oppo-') && a.textContent.trim() !== 'Oppo');
      const series = [];
      let active = null;
      links.forEach(link => {
        if (/series$/i.test(link.textContent.trim())) {
          active = {link,models:[]};
          series.push(active);
        } else if (active) active.models.push(link);
      });
      if (!series.length) return;
      list.dataset.qfmOppoSeries = 'true';
      const brand = document.createElement('li');
      brand.className = 'mobile-menu__nav-item qfm-oppo-mobile-title';
      const label = document.createElement('span');
      label.className = 'mobile-menu__nav-link text--strong';
      label.textContent = 'Oppo · All series';
      brand.append(label);
      const items = [brand];
      series.forEach(entry => {
        const item = document.createElement('li');
        item.className = 'mobile-menu__nav-item qfm-oppo-mobile-series';
        const all = entry.link.cloneNode(true);
        const seriesProducts = oppoModelLinks(entry.link.getAttribute('href'),'mobile-menu__nav-link');
        const mobileLinks = entry.models.length ? entry.models : seriesProducts;
        if (mobileLinks.length) {
          const details = document.createElement('details');
          const summary = document.createElement('summary');
          summary.className = 'mobile-menu__nav-link text--strong';
          summary.textContent = entry.link.textContent.trim();
          const children = document.createElement('ul');
          children.className = 'mobile-menu__nav qfm-oppo-mobile-models';
          [all,...mobileLinks.map(link => link.cloneNode(true))].forEach((link,index) => {
            const li = document.createElement('li');
            li.className = 'mobile-menu__nav-item';
            if (!index) link.textContent = 'Shop all ' + entry.link.textContent.trim();
            li.append(link);
            children.append(li);
          });
          details.append(summary,children);
          item.append(details);
        } else item.append(all);
        items.push(item);
      });
      list.replaceChildren(...items);
    });
  };

  const setupAllMenus = () => { document.querySelectorAll('.nav-bar__link[aria-controls]').forEach(setupSpareMenu); setupOppoMobile(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',setupAllMenus);
  else setupAllMenus();
  document.addEventListener('shopify:section:load',setupAllMenus);
})();

;(() => {
 const setup = () => {
  document.querySelectorAll('.search-bar__filter').forEach((filter,index) => {
   const select=filter.querySelector('select');
   if(!select || filter.classList.contains('qfm-category-ready')) return;
   filter.classList.add('qfm-category-ready');
   if(!document.getElementById('qfm-category-style')){
    const style=document.createElement('style');style.id='qfm-category-style';
    style.textContent=`
.qfm-category-ready>select,.qfm-category-ready>.search-bar__filter-label{display:none!important}
.qfm-category-trigger{display:flex;align-items:center;gap:12px;max-width:220px;height:100%;min-height:44px;padding:0 18px;border:0;border-left:1px solid #dce7ef;background:#f3f8fc;color:#164e79;font:inherit;font-size:14px;font-weight:600;cursor:pointer}
.qfm-category-trigger span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.qfm-category-trigger:after{content:'';width:7px;height:7px;border-right:2px solid currentColor;border-bottom:2px solid currentColor;transform:rotate(45deg);flex:none;margin-top:-4px;transition:transform .2s}
.qfm-category-trigger[aria-expanded=true]:after{transform:rotate(225deg);margin-top:3px}
.qfm-category-trigger:hover{background:#e7f3fc}
.qfm-category-trigger:focus-visible{outline:2px solid #0078b7;outline-offset:-3px}
.qfm-category-panel{position:fixed;z-index:10000;background:white;border:1px solid #dce8f2;border-radius:14px;box-shadow:0 16px 44px #07326936;padding:18px;color:#20394d;display:flex;flex-direction:column;overflow:hidden}
.qfm-category-panel[hidden]{display:none!important}
.qfm-category-top{display:flex;align-items:center;justify-content:space-between;margin-bottom:12px;gap:12px}
.qfm-category-top strong{font-size:16px;color:#0b426e}
.qfm-category-close{border:0;border-radius:6px;background:#eef5fb;color:#164e79;width:30px;height:30px;cursor:pointer;font-size:20px}
.qfm-category-find{flex:none;width:100%;border:1px solid #cbdde9;background:#f8fbfe;border-radius:8px;padding:10px 12px;font:inherit;font-size:14px;color:#20394d}
.qfm-category-find:focus{outline:2px solid #1395c9;outline-offset:1px}
.qfm-category-options{overflow-y:auto;overscroll-behavior:contain;min-height:0;padding-top:10px;scrollbar-gutter:stable}
.qfm-category-options section{margin:0 0 14px}
.qfm-category-options h3{font-size:11px;letter-spacing:.8px;text-transform:uppercase;color:#6c8395;margin:8px 4px;font-weight:700}
.qfm-category-choices{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:4px 8px}
.qfm-category-choice{font:inherit;font-size:13px;line-height:19px;text-align:left;padding:8px 10px;color:#284d69;border:1px solid transparent;background:white;border-radius:7px;cursor:pointer;overflow-wrap:anywhere}
.qfm-category-choice:hover,.qfm-category-choice:focus-visible{background:#eef7fd;color:#0064a7}
.qfm-category-choice[aria-pressed=true]{background:#e2f2ff;border-color:#b9ddf6;color:#075aa1;font-weight:600}
.qfm-category-empty{font-size:14px;padding:14px;color:#637d91}
@media(prefers-reduced-motion:no-preference){.qfm-category-panel:not([hidden]){animation:qfm-category-popup .2s ease-out}@keyframes qfm-category-popup{from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:translateY(0)}}}
@media(max-width:600px){.qfm-category-trigger{max-width:140px;padding:0 10px}.qfm-category-choices{grid-template-columns:1fr}}
`;
    document.head.append(style);
   }
   const trigger=document.createElement('button');trigger.type='button';trigger.className='qfm-category-trigger';
   const label=document.createElement('span');trigger.append(label);
   trigger.setAttribute('aria-expanded','false');trigger.setAttribute('aria-haspopup','dialog');
   const panel=document.createElement('div');panel.className='qfm-category-panel';panel.hidden=true;panel.id='qfm-category-panel-'+index;
   panel.setAttribute('role','dialog');panel.setAttribute('aria-label','Choose a search category');trigger.setAttribute('aria-controls',panel.id);
   const top=document.createElement('div');top.className='qfm-category-top';
   const title=document.createElement('strong');title.textContent='Shop by category';
   const close=document.createElement('button');close.type='button';close.className='qfm-category-close';close.textContent='×';close.setAttribute('aria-label','Close categories');top.append(title,close);
   const input=document.createElement('input');input.type='search';input.className='qfm-category-find';input.placeholder='Find a category…';input.setAttribute('aria-label','Find a category');
   const options=document.createElement('div');options.className='qfm-category-options';
   const records=Array.from(select.options).map(o=>({value:o.value,label:o.textContent.trim()}));
   const buckets=['Browse everything','Phones & tablets','Spare parts','Accessories','Repairs & services'];
   const bucket=r=>!r.value?0:/accessor|case|protector|stylus/i.test(r.label)?3:/parts|screen|battery|camera|charging|flex|speaker|sim tray|housing|back cover/i.test(r.label)?2:/repair service|repair tools|installation|warranty|^service$/i.test(r.label)?4:1;
   const update=()=>{label.textContent=select.value ? select.selectedOptions[0].textContent : 'Shop by Category';trigger.setAttribute('aria-label','Search category: '+label.textContent);};
   const hide=(focus=false)=>{panel.hidden=true;trigger.setAttribute('aria-expanded','false');if(focus)trigger.focus();};
   const render=()=>{
    options.replaceChildren();let total=0;const query=input.value.trim().toLowerCase();
    buckets.forEach((name,i)=>{
     const matches=records.filter(r=>bucket(r)===i&&r.label.toLowerCase().includes(query));if(!matches.length)return;
     const section=document.createElement('section'),heading=document.createElement('h3'),choices=document.createElement('div');heading.textContent=name;choices.className='qfm-category-choices';
     matches.forEach(r=>{const b=document.createElement('button');b.type='button';b.className='qfm-category-choice';b.textContent=r.label;b.setAttribute('aria-pressed',String(select.value===r.value));b.addEventListener('click',()=>{select.value=r.value;select.dispatchEvent(new Event('change',{bubbles:true}));update();hide(true);});choices.append(b);total++;});
     section.append(heading,choices);options.append(section);
    });
    if(!total){const p=document.createElement('p');p.className='qfm-category-empty';p.textContent='No categories found.';options.append(p);}
   };
   const position=()=>{const r=trigger.getBoundingClientRect(),width=Math.min(540,window.innerWidth-24),left=Math.max(12,Math.min(r.right-width,window.innerWidth-width-12)),top=Math.max(12,r.bottom+10);panel.style.left=left+'px';panel.style.top=top+'px';panel.style.width=width+'px';panel.style.maxHeight=Math.max(140,Math.min(550,window.innerHeight-top-16))+'px';};
   trigger.addEventListener('click',()=>{if(!panel.hidden){hide();return;}input.value='';render();position();panel.hidden=false;trigger.setAttribute('aria-expanded','true');input.focus();});
   close.addEventListener('click',()=>hide(true));
   input.addEventListener('input',render);input.addEventListener('keydown',e=>{if(e.key==='Enter')e.preventDefault();});
   panel.addEventListener('keydown',e=>{if(e.key==='Escape'){e.preventDefault();hide(true);}if(e.key==='ArrowDown'&&e.target===input){e.preventDefault();options.querySelector('button')?.focus();}});
   document.addEventListener('click',e=>{if(!panel.contains(e.target)&&!trigger.contains(e.target))hide();});
   window.addEventListener('resize',()=>{if(!panel.hidden)position();},{passive:true});
   window.addEventListener('scroll',()=>{if(!panel.hidden)hide();},{passive:true});
   select.addEventListener('change',update);filter.append(trigger);document.body.append(panel);panel.append(top,input,options);update();
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
 document.addEventListener('shopify:section:load',setup);
})();
